// src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { useGoogleLogin } from "@react-oauth/google";

const AuthContext = createContext();

let globalAccessToken = null;

export const getAccessToken = () => globalAccessToken;

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);

  // Cek session dari localStorage saat mount (TANPA auto-login)
  useEffect(() => {
    const storedUser = localStorage.getItem("google_user");
    const storedToken = localStorage.getItem("google_access_token");

    if (storedUser && storedToken) {
      try {
        const userData = JSON.parse(storedUser);
        setUser(userData);
        setAccessToken(storedToken);
        globalAccessToken = storedToken;
        console.log("✅ Session restored for:", userData.email);
      } catch (e) {
        console.error("Error restoring session:", e);
        localStorage.removeItem("google_user");
        localStorage.removeItem("google_access_token");
      }
    }
    setIsInitialized(true);
  }, []);

  // Google Login - HANYA dipanggil saat user klik tombol Login
  const login = useGoogleLogin({
    onSuccess: (response) => {
      console.log("✅ Login Success:", response);
      setAccessToken(response.access_token);
      globalAccessToken = response.access_token;

      localStorage.setItem("google_access_token", response.access_token);
      fetchUserInfo(response.access_token);
    },
    onError: (error) => {
      console.error("❌ Login Failed:", error);
      setError("Login gagal. Silakan coba lagi.");
    },
    scope:
      "https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile",
    flow: "implicit",
  });

  const fetchUserInfo = async (token) => {
    try {
      const response = await fetch(
        "https://www.googleapis.com/oauth2/v1/userinfo",
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (!response.ok) throw new Error("Failed to fetch user info");

      const userInfo = await response.json();
      setUser(userInfo);
      localStorage.setItem("google_user", JSON.stringify(userInfo));
      console.log("👤 User info:", userInfo.email);
    } catch (error) {
      console.error("Error fetching user info:", error);
      setError("Gagal mendapatkan informasi user");
    }
  };

  const logout = () => {
    setUser(null);
    setAccessToken(null);
    globalAccessToken = null;
    localStorage.removeItem("google_user");
    localStorage.removeItem("google_access_token");
    console.log("🔓 Logged out");
  };

  const value = {
    user,
    accessToken,
    loading,
    error,
    login,
    logout,
    isAuthenticated: !!user && !!accessToken,
    isInitialized,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
